import { render, staticRenderFns } from "./AddressStats.vue?vue&type=template&id=899ea94a&scoped=true&"
import script from "./AddressStats.vue?vue&type=script&lang=js&"
export * from "./AddressStats.vue?vue&type=script&lang=js&"
import style0 from "./AddressStats.vue?vue&type=style&index=0&id=899ea94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899ea94a",
  null
  
)

export default component.exports